module.exports = __webpack_public_path__ + "static/assets/66644f76b3f90ffeeb9bec0ffd4bccdb.jpg";